import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API_URL = "http://127.0.0.1:8000/api/material/create_record/";

function MaterialExpenseDashboard() {
  const { roomid } = useParams();

  const [expenses, setExpenses] = useState([]);
  const [form, setForm] = useState({
    date: "",
    product_category: "",
    product_name: "",
    // remark: "",
    cost: "",
  });

  // Fetch data
  useEffect(() => {
    fetchExpenses();
  }, []);

  const fetchExpenses = async () => {
    try {
      const response = await axios.get(`${API_URL}?room_id=${roomid}`);
      setExpenses(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Handle input change
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // Submit form
  const handleAddExpense = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(API_URL, {
        RoomId: roomid,
        Date: form.date,
        ProductCategory: form.product_category,
        ProductName: form.product_name,
        // remark: form.remark,
        Cost: parseFloat(form.cost),
      });

      setExpenses([...expenses, response.data]);

      setForm({
        date: "",
        product_category: "",
        product_name: "",
        // remark: "",
        cost: "",
      });

    } catch (error) {
      console.error("Error saving:", error);
      alert("Failed to save data");
    }
  };

  // Calculate total cost
  const totalCost = expenses.reduce((sum, item) => {
    return sum + (parseFloat(item.cost) || 0);
  }, 0);

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Material Expenses - Room {roomid}</h2>

      {/* Form */}
      <div className="card mb-4 border-primary">
        <div className="card-header bg-primary text-white">
          Add Expense
        </div>

        <div className="card-body">
          <form onSubmit={handleAddExpense}>
            <div className="row g-3">

              <div className="col-md-2">
                <input
                  type="date"
                  name="date"
                  value={form.date}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              <div className="col-md-2">
                <select
                  name="product_category"
                  value={form.product_category}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">Category</option>
                  <option value="cement">Cement</option>
                  <option value="steel">Steel</option>
                  <option value="sand">Sand</option>
                  <option value="bricks">Bricks</option>
                  <option value="paint">Paint</option>
                </select>
              </div>

              <div className="col-md-2">
                <input
                  type="text"
                  name="product_name"
                  placeholder="Product Name"
                  value={form.product_name}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              {/* <div className="col-md-2">
                <input
                  type="text"
                  name="remark"
                  placeholder="Remark"
                  value={form.remark}
                  onChange={handleChange}
                  className="form-control"
                />
              </div> */}

              <div className="col-md-2">
                <div className="input-group">
                  <span className="input-group-text">₹</span>
                  <input
                    type="number"
                    name="cost"
                    placeholder="Cost"
                    value={form.cost}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>
              </div>

              <div className="col-md-2">
                <button type="submit" className="btn btn-success w-100">
                  Add
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>

      {/* Table */}
      <table className="table table-hover shadow-sm">
        <thead className="table-dark">
          <tr>
            <th>Date</th>
            <th>Category</th>
            <th>Product</th>
            {/* <th>Remark</th> */}
            <th>Cost</th>
          </tr>
        </thead>

        <tbody>
          {expenses.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center text-muted">
                No data found
              </td>
            </tr>
          ) : (
            expenses.map((item) => (
              <tr key={item.id}>
                <td>{item.date}</td>
                <td>{item.product_category}</td>
                <td>{item.product_name}</td>
                {/* <td>{item.remark}</td> */}
                <td>₹{item.cost}</td>
              </tr>
            ))
          )}
        </tbody>

        {/* Total */}
        <tfoot>
          <tr className="table-secondary">
            <td colSpan="3" className="text-end fw-bold">Total</td>
            <td className="fw-bold">₹{totalCost.toFixed(2)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default MaterialExpenseDashboard;